module.exports = __webpack_public_path__ + "img/banner-two-main-pic.b98d88d7.png";